import { useNuxtApp } from "#app"

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const apiKey = config.public.googleMapsKey
  const app = useNuxtApp()

  useHead({
    script: [
      {
        // v3.58 to v3.61 is not working on Safari 15 and older
        src: `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&language=${app.$i18n.locale.value}&libraries=places&v=3.57`,
        defer: true
      }
    ]
  })
})
